const getAspectRatio = (src: string): Promise<number[]> => {
  return new Promise((resolve) => {
    const img = document.createElement('img');
    img.src = src;
    img.onload = () => {
      img.style.visibility = 'hidden';
      document.body.appendChild(img);
      resolve([img.clientWidth, img.clientHeight]);
      document.body.removeChild(img);
    };
  });
};

/**
 * Calculate x and y in circle's circumference
 * @param {number} r - The circle's radius
 * @param {number} angle - The angle in degrees
 * @param {number} cx - The circle's origin x
 * @param {number} cz - The circle's origin z
 * @returns {Array[number,number]} The calculated x and y
 */
// eslint-disable-next-line class-methods-use-this
const pointsOnCircle2D = (r: number, angle: number, cx: number, cz: number) => {
  const a = angle * (Math.PI / 180); // convert from degrees to radians
  const x = cx + r * Math.cos(a);
  const z = cz + r * Math.sin(a);
  return [x, z];
};

export { getAspectRatio, pointsOnCircle2D };
